import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'reactstrap';
import { Link } from 'react-router-dom';

import Content from '../../../layout/Content';
import Alert from '../../../common/informative/Alert';

import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import { ENTER_DATA_TO_SHOW_DATA } from '../../../../config/messages';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import { tzNormalizeDate } from '../../../../utils/date';

import { NEW_PREVENTIVE_TASK_EXECUTION_PATH } from '../../../../config/paths';

import PreventiveTaskExecutionHistorySearchForm from './PreventiveTaskExecutionHistorySearchForm';
import {
  clearPreventiveTaskExecutions,
  postPreventiveTaskExecutions,
} from '../../../../actions/task-schedule/PreventiveTaskExecution';
import PreventiveTaskExecutionHistoryResult from './PreventiveTaskExecutionHistoryResult';

const PreventiveTaskExecutionHistory = ({
  breadcrumbs,
  dispatchGetPreventiveTaskExecutions,
  dispatchClearPreventiveTaskExecutions,
}) => {
  const [searchValues, setSearchValues] = useState(null);

  const today = tzNormalizeDate({ format: INT_DATE_FORMAT });

  const onSearch = (values) => {
    dispatchClearPreventiveTaskExecutions();
    dispatchGetPreventiveTaskExecutions(values);
  };

  const onSubmitSearch = (formValues) => {
    const newSearchValues = {
      startedDateFrom: tzNormalizeDate({
        date: formValues.dateFrom,
        time: 'start',
      }),
      completedDateTo: tzNormalizeDate({
        date: formValues.dateTo,
        time: 'end',
      }),
      view: formValues.view || 'USER',
      ...DEFAULT_QUERY_GET_ALL,
    };

    setSearchValues(newSearchValues);
    onSearch(newSearchValues);
  };
  const toolBar = (
    <ButtonToolbar className="pull-right">
      <div>
        <Link to={NEW_PREVENTIVE_TASK_EXECUTION_PATH}>
          <Button color="primary">
            <i className="fa fa-play mr-1" />
            Comenzar ejecución
          </Button>
        </Link>
      </div>
    </ButtonToolbar>
  );

  let table = <Alert type="info" message={ENTER_DATA_TO_SHOW_DATA} />;

  if (searchValues) {
    table = <PreventiveTaskExecutionHistoryResult />;
  }

  const content = (
    <>
      <PreventiveTaskExecutionHistorySearchForm
        onSubmit={onSubmitSearch}
        initialValues={{
          dateFrom: today,
          dateTo: today,
          view: 'USER',
        }}
      />

      <div className="mt-3">{table}</div>
    </>
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Historial de Ejecuciones Programadas"
      toolbar={toolBar}
      content={content}
    />
  );
};

PreventiveTaskExecutionHistory.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetPreventiveTaskExecutions: PropTypes.func.isRequired,
  dispatchClearPreventiveTaskExecutions: PropTypes.func.isRequired,
};

const mapStateToProps = ({ TaskScheduleUnit }) => ({
  breadcrumbs: [
    ...TaskScheduleUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Historial de Ejecuciones Programadas',
      href: '',
    },
  ],
});

const mapDispatchToProps = {
  dispatchGetPreventiveTaskExecutions: postPreventiveTaskExecutions,
  dispatchClearPreventiveTaskExecutions: clearPreventiveTaskExecutions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreventiveTaskExecutionHistory);
